cockpitApp.controller('overviewController', [
  '$rootScope', 'gettextCatalog',
  function ($rootScope, gettextCatalog)
  {
    $rootScope.appTitle = $rootScope.appName + ' - ' + gettextCatalog.getString('Overview');
  }
]);
